// Module
var code = "<div class=\"dms-tree-wrapper dms-outer-element\">\n    <div class=\"dms-grid-wrapper dms-tree #=data.GridName#\"></div>\n</div>\n";
// Exports
export default code;